<div class="root">
  <span class="root__title">{{ title }}</span>

  <div class="status-container">
    @for (item of stages; track $index) {
      <div class="status">
        <div
          class="status__bubble"
          [ngClass]="{
            'status__bubble--active': item.value === value,
            'status__bubble--next':
              (valueIndex > $index || valueIndex === $index - 1) &&
              !(stages[$index - 1] && stages[$index - 1].isCancel),
            'status__bubble--canceled': item.isCancel,
          }"
        >
          {{ $index + 1 }}
        </div>
        <span class="status__title">{{ item.label }}</span>
      </div>
      <div
        *ngIf="stages.length !== $index + 1"
        class="status-container__line"
        [ngClass]="{
          'status-container__line--active': valueIndex >= $index && !item.isCancel,
        }"
      ></div>
    }
  </div>
</div>
